module.exports = __webpack_public_path__ + "static/20250703_HSE_Closing_Announcement_final-7ba98d7a6010b173a3aff3590d004813.pdf";